import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('trip_facility_id')
];

const config: IFormConfig = { 
	title: 'Aggiungi Informazione al pacchetto',
	fields: formFields 
};

export default config;
